import { render, staticRenderFns } from "./ProjectNeed.vue?vue&type=template&id=117cb002&scoped=true"
import script from "./ProjectNeed.vue?vue&type=script&lang=js"
export * from "./ProjectNeed.vue?vue&type=script&lang=js"
import style0 from "./ProjectNeed.vue?vue&type=style&index=0&id=117cb002&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cb002",
  null
  
)

export default component.exports